"use strict";

(function() {

  Blockly.Blocks['robotica_motor'] = {
    init: function() {
      this.appendValueInput("leftWheel")
          .setCheck("Number")
          .appendField("Rueda izquierda");
      this.appendValueInput("rightWheel")
          .setCheck("Number")
          .appendField("Rueda derecha");
      this.appendValueInput("duration")
          .setCheck("Number")
          .appendField("Duración");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(65);
      this.setTooltip('Hacer que el robot se mueva con determinada potencia en cada rueda durante el tiempo definido.');
      this.setHelpUrl('http://www.example.com/');
    }
  };

  /* TODO repeated code */
  Blockly.JavaScript['robotica_motor'] = function(block) {
    var value_leftwheel = Blockly.JavaScript.valueToCode(block, 'leftWheel', Blockly.JavaScript.ORDER_ATOMIC);
    var value_rightwheel = Blockly.JavaScript.valueToCode(block, 'rightWheel', Blockly.JavaScript.ORDER_ATOMIC);
    var value_duration = Blockly.JavaScript.valueToCode(block, 'duration', Blockly.JavaScript.ORDER_ATOMIC);
    var code = "motor(" + value_leftwheel + ', ' + value_rightwheel + ', ' + value_duration + ');\n';
    return code;
  };

  Blockly.Arduino['robotica_motor'] = function(block) {
    var value_leftwheel = Blockly.JavaScript.valueToCode(block, 'leftWheel', Blockly.JavaScript.ORDER_ATOMIC);
    var value_rightwheel = Blockly.JavaScript.valueToCode(block, 'rightWheel', Blockly.JavaScript.ORDER_ATOMIC);
    var value_duration = Blockly.JavaScript.valueToCode(block, 'duration', Blockly.JavaScript.ORDER_ATOMIC);
    var code = "motor(" + value_leftwheel + ', ' + value_rightwheel + ', ' + value_duration + ');\n';
    return code;
  }

  Blockly.Blocks['robotica_sensor'] = {
    init: function() {
      this.setOutput(true, Blockly.Types.NUMBER.output);
      this.appendDummyInput()
          .appendField("Sensor")
          .appendField(new Blockly.FieldDropdown([["Izquierda", "left"], ["Derecha", "right"], ["Adelante", "front"]]), "Sensor");
      this.setColour(65);
      this.setTooltip('Activa el sensor de proximidad en la dirección determinada.');
      this.setHelpUrl('http://www.example.com/');
    },
    getBlockType: function() {
      return Blockly.Types.NUMBER;
    }
  };

  /* TODO repeated code */
  Blockly.JavaScript['robotica_sensor'] = function(block) {
    var dropdown_sensor = block.getFieldValue('Sensor');
    var code = 'sensor(\'' + dropdown_sensor + '\')';
    return [code, Blockly.JavaScript.ORDER_ATOMIC];
  };

  Blockly.Arduino['robotica_sensor'] = function(block) {
    var dropdown_sensor = block.getFieldValue('Sensor');
    var code = 'sense('+ dropdown_sensor + ')';
    return [code, Blockly.JavaScript.ORDER_ATOMIC];
  };

  /* Enables or disables tracing support */
  Blockly.Blocks['robotica_tracer_status'] = {
    init: function() {
      this.appendValueInput("enable")
          .setCheck("Boolean")
          .appendField("Traza habilitada");
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(65);
      this.setTooltip('Si es verdadero, entonces habilita la traza.');
      this.setHelpUrl('http://www.example.com/');
    }
  };

  Blockly.JavaScript['robotica_tracer_status'] = function(block) {
    var value_enable = Blockly.JavaScript.valueToCode(block, 'enable', Blockly.JavaScript.ORDER_ATOMIC);
    var code = 'tracer(' + value_enable + ');\n';
    return code;
  };

  Blockly.Arduino['robotica_tracer_status'] = function(block) {
    return "";
  };

  /* Sets tracer's colour */
  Blockly.Blocks['robotica_tracer_colour'] = {
    init: function() {
      this.appendDummyInput()
          .appendField("Color de traza")
          .appendField(new Blockly.FieldColour("#ff0000"), "trace_colour");
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(65);
      this.setTooltip('Define el color de la traza.');
      this.setHelpUrl('http://www.example.com/');
    }
  };

  Blockly.JavaScript['robotica_tracer_colour'] = function(block) {
    var trace_colour = block.getFieldValue('trace_colour');
    var code = 'tracer_colour(\''+ trace_colour +'\');\n';
    return code;
  };

  Blockly.Arduino['robotica_tracer_colour'] = function(block) {
    return "";
  };

  /* Just for debugging */
  Blockly.Blocks['console_log'] = {
    init: function() {
      this.appendValueInput("text")
          .setCheck(null)
          .appendField("Texto");
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(20);
      this.setTooltip('');
      this.setHelpUrl('http://www.example.com/');
    }
  };

  Blockly.JavaScript['console_log'] = function(block) {
    var value_text = Blockly.JavaScript.valueToCode(block, 'text', Blockly.JavaScript.ORDER_ATOMIC);
    // TODO: Assemble JavaScript into code variable.
    var code = 'console_log(' + value_text + ');\n';
    return [code, Blockly.JavaScript.ORDER_ATOMIC];
  };

})();



"use strict";

String.prototype.format = String.prototype.format ||
function () {
    var str = this.toString();
    if (arguments.length) {
        var t = typeof arguments[0];
        var key;
        var args = ("string" === t || "number" === t) ?
            Array.prototype.slice.call(arguments)
            : arguments[0];

        for (key in args) {
            str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
        }
    }

    return str;
};
"use strict";

this.app = app || {};

this.app.models = app.models || {};

this.app.models.Blockly = Backbone.Model.extend({
  defaults: {},

  initialize: function() {

  },

  exportWorkspaceXml : function() {
    var xmlDom = Blockly.Xml.workspaceToDom(this.get('workspace'));
    var xmlText = Blockly.Xml.domToPrettyText(xmlDom);
    return xmlText;
  },

  addWorkspaceOnChangeListener : function(onChange) {
    this.get('workspace').addChangeListener(onChange);
  },

  removeWorkspaceOnChangeListener : function(onChange) {
    this.get('workspace').removeChangeListener(onChange);
  },

  exportWorkspaceArduino : function() {
    var code = Blockly.Arduino.workspaceToCode(this.get('workspace'));
    var setupRE = /void setup\(.*\) \{([\s\S]*?)\}[\s\S]*void loop/;
    var loopRE = /void loop\(.*\) \{([\s\S]*?)\s\}$/;
    var allDefsRE = /([\s\S]*?)void setup()/;
    var allDefs = code.match(allDefsRE)[1];
    var setup = code.match(setupRE)[1];
    var loop = code.match(loopRE)[1];
    return arduinoCode.format(allDefs, setup, loop);
  },

  exportWorkspaceJavascript : function() {
    return Blockly.JavaScript.workspaceToCode(this.get('workspace'));
  },

  importWorkspaceXml : function(xmlText) {
    this.get('workspace').clear();
    var xmlDom = Blockly.Xml.textToDom(xmlText);
    Blockly.Xml.domToWorkspace(xmlDom, this.get('workspace'));
  },

  codeIsEmpty : function() {
    var code = Blockly.JavaScript.workspaceToCode(this.get('workspace'));
    return !code || !code.trim().length
  },

  clearWorkspace : function() {
    this.get('workspace').clear();
  }
});
"use strict";

this.app = app || {};

this.app.models = app.models || {};

this.app.models.FileSave = Backbone.Model.extend({
  defaults: {
    fileExtension : '',
    defaultFileName : '',
    extractCode : function() {}
  },

  initialize: function() {
  },

  downloadWithFileName : function(fileName) {
    var text = this.get('extractCode')();
    this.saveTextAsFile(text, this.formatFileName(fileName, this.get('fileExtension')));
  },

  saveTextAsFile : function(text, filename) {
    /* Saves a text string as a blob file*/  
    var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/);
    var ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);
    var ieEDGE = navigator.userAgent.match(/Edge/g);
    var ieVer=(ie ? ie[1] : (ie11 ? 11 : (ieEDGE ? 12 : -1)));

    if (ie && ieVer < 10) {
      console.log("No blobs on IE ver < 10.");
      return;
    }

    var textFileAsBlob = new Blob([text], {
      type: 'text/plain'
    });

    if (ieVer > -1) {
      window.navigator.msSaveBlob(textFileAsBlob, filename);
    } else {
      var downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
      downloadLink.onclick = function(e) { document.body.removeChild(e.target); };
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  },

  formatFileName : function(fileName, extension) {
    fileName = fileName || this.get('defaultFileName') + extension;
    if (fileName.length < 4 || fileName.substr(fileName.length - 4) != extension) {
      fileName += extension;
    }
    return fileName;
  }

});
"use strict";

this.app = app || {};

this.app.models = app.models || {};

this.app.models.Simulator = Backbone.Model.extend({
  initialize : function() {
    this.onWorkspaceChangeCallback = $.proxy(this.onWorkspaceChange, this);
  },
  enableSensorsHUD : function() {
    me.game.HUD.enableHUD();
  },

  disableSensorsHUD : function() {
    me.game.HUD.disableHUD();
  },

  onWorkspaceChange : function(event) {
    if(event.type == Blockly.Events.CHANGE || 
      event.type == Blockly.Events.CREATE || 
      event.type == Blockly.Events.DELETE) {
      /* If the code was modified, finish the execution */
      me.execution.finish();
      /* Remove the event listener */
      app.blocklyModel.removeWorkspaceOnChangeListener(this.onWorkspaceChangeCallback);
    }
  },

  pause : function(onPause) {
    if(me.execution.isRunning()) {
      onPause();
      me.execution.pause();
      /* While being paused, check if the code was modified */
      app.blocklyModel.addWorkspaceOnChangeListener(this.onWorkspaceChangeCallback);
    }
  },

  stop : function(onStop) {
    if(!me.execution.hasFinished()) {
      onStop();
      me.execution.finish();
      me.state.change(me.state.PLAY);
    }
  },

  run : function(onRun, onCompleted) {
    if(me.execution.hasFinished()) {
      var code = app.blocklyModel.exportWorkspaceJavascript();
      if(!code.length) {
        module.notifyEmptyProgram();
        return;
      }
      me.state.pause();
      me.state.change(me.state.PLAY);
      me.execution.onCompleted = onCompleted;
      me.interpreter = this.get('interpreter').createInterpreter(code);
      me.state.resume();
    }
    if(me.execution.isPaused()) {
      /* Remove the event listener */
      app.blocklyModel.removeWorkspaceOnChangeListener(this.onWorkspaceChangeCallback);
    }
    if(!me.execution.isRunning()) {
      onRun();
      me.execution.run();
    }
  },

  changeMap : function(mapName) {
    app.blocklyModel.clearWorkspace();
    me.game.changeMap(mapName);
  },

  notifyEmptyProgram : _.throttle(function() {
    toastr.info('No hay código para ejecutar.', 'Programa vacío', {timeOut: 2000});
  }, 3000, {trailing: false}),

  notifySaturationLeftWheel : _.throttle(function() {
    this.notifySaturation('La potencia de la rueda izquierda está fuera del rango [-100, 100].');
  }, 3000, {trailing: false}),

  notifySaturationRightWheel : _.throttle(function() {
    this.notifySaturation('La potencia de la rueda derecha está fuera del rango [-100, 100].');
  }, 3000, {trailing: false}),

  notifySaturation : function(mensaje) {
    toastr.warning(mensaje, 'Potencia fuera de límite', {timeOut: 2000});
  }
});
"use strict";

this.app = app || {};

this.app.models = app.models || {};

this.app.models.SimulatorInterpreter = Backbone.Model.extend({
  initialize : function() {

  },

  createInterpreter : function(code) {
    return new Interpreter(code, this.initApi);
  },

  initApi : function(interpreter, scope) {
    interpreter.robotInstructions = new Array();

    /* Add an API function for the motor function */
    var motorWrapper = function(leftWheelValue, rightWheelValue, durationValue) {
      if (leftWheelValue.data < -100 || leftWheelValue.data > 100) {
        leftWheelValue.data = Math.max(-100, Math.min(100, leftWheelValue.data));
        app.simulatorModel.notifySaturationLeftWheel();
      }
      if (rightWheelValue.data < -100 || rightWheelValue.data > 100) {
        rightWheelValue.data = Math.max(-100, Math.min(100, rightWheelValue.data));
        app.simulatorModel.notifySaturationRightWheel();
      }
      return interpreter.createPrimitive(
        interpreter.robotInstructions.push(
          {action : 'motor', 
          leftWheel : leftWheelValue.data,
          rightWheel : rightWheelValue.data,
          duration : durationValue.data
          })
      );
    };

    /* Add an API function for the sensor function */
    var sensorWrapper = function(sensorName, callback) {
      interpreter.robotInstructions.push({
        action : 'sensor',
        sensorName : sensorName,
        sensorResultCallback : callback
      });
    };

    /* Add an API function for the tracer enabler */
    var tracerEnableWrapper = function(enabled) {
      interpreter.robotInstructions.push(
        {action : 'tracer_status', 
          enabled: enabled
        });
      return interpreter.createPrimitive(null);
    };

    /* Add an API function for the tracer colour */
    var tracerColourWrapper = function(colour) {
      interpreter.robotInstructions.push(
        {action : 'tracer_colour', 
          colour: colour
        })
      return interpreter.createPrimitive(null);
    };

    var consoleLogWrapper = function(text) {
      console.log("Console log: ");
      console.log(text.data);
      return interpreter.createPrimitive(null);
    };

    interpreter.setProperty(scope, 'sensor',
        interpreter.createAsyncFunction(sensorWrapper));
    interpreter.setProperty(scope, 'motor',
        interpreter.createNativeFunction(motorWrapper));
    interpreter.setProperty(scope, 'console_log',
        interpreter.createNativeFunction(consoleLogWrapper));
    interpreter.setProperty(scope, 'tracer_colour',
        interpreter.createNativeFunction(tracerColourWrapper));
    interpreter.setProperty(scope, 'tracer',
        interpreter.createNativeFunction(tracerEnableWrapper));
  }
});
"use strict";

this.app = app || {};

this.app.views = app.views || {};

app.views.AppView = Backbone.View.extend({
  initialize : function() {
    $.material.init();
    this.$homeNavbarCollapseElement = this.$el.find('#home-navbar-collapse');
    this.$homeContentElement = this.$el.find("#home-content");
    this.$homeBlocklyWrapperElement = this.$el.find("#home-blockly-wrapper");
    this.$homeSimulatorWrapperElement = this.$el.find("#home-simulator-wrapper");
    this.$mapsModalElement = $("#maps-modal");
    this.$stateIndicatorElement = $("#state-indicator");
    
    this.setInitialLayoutMode();

    this.$homeNavbarCollapseElement.on('shown.bs.collapse hidden.bs.collapse', app.blocklyView.forceBlocklySvgResize);
    this.$homeSimulatorWrapperElement.click($.proxy(this.toggleLayoutMode, this));
  },
  setInitialLayoutMode : function() {
    if (_.contains(["xs", "sm"], this.getState())) {
      this.setLayoutModeCollapsed();
    } else { /* ["md", "lg"] */
      this.setLayoutModeExpanded();
    }
  },

  setLayoutModeCollapsed : function() {
    this.$homeContentElement.removeClass('content-expanded');
    this.$homeSimulatorWrapperElement.removeClass('simulator-expanded');
    this.$homeBlocklyWrapperElement.removeClass('blockly-expanded');
    this.$homeContentElement.addClass('content-collapsed');
    this.$homeSimulatorWrapperElement.addClass('simulator-collapsed');
    this.$homeBlocklyWrapperElement.addClass('blockly-collapsed');
    app.simulatorView.enableSimulatorDragging();
    app.simulatorView.onContainerResize();
    app.blocklyView.onContainerResize();
  },
  
  setLayoutModeExpanded : function() {
    this.$homeContentElement.removeClass('content-collapsed');
    this.$homeSimulatorWrapperElement.removeClass('simulator-collapsed');
    this.$homeBlocklyWrapperElement.removeClass('blockly-collapsed');
    this.$homeContentElement.addClass('content-expanded');
    this.$homeSimulatorWrapperElement.addClass('simulator-expanded');
    this.$homeBlocklyWrapperElement.addClass('blockly-expanded');
    app.simulatorView.disableSimulatorDragging();
    app.simulatorView.onContainerResize();
    app.blocklyView.onContainerResize();
  },
  
  toggleLayoutMode : function() {
    if(this.$homeContentElement.hasClass('content-expanded')) {
      this.setLayoutModeCollapsed();
    } else {
      this.setLayoutModeExpanded();
    }
  },

  getState : function() {
    var computedStyle = window.getComputedStyle(this.$stateIndicatorElement[0], ':before');
    return computedStyle.getPropertyValue('content').replace(/"/g,'') || 'unknown';
  }

});
"use strict";

this.app = app || {};

this.app.views = app.views || {};

this.app.views.Blockly = Backbone.View.extend({

  events: {
    'change #hidden-file-input' : 'onHiddenFileInputChange',
  },

  render : function() {
    var blocklyOptions = {
      media: 'assets/blockly/',
      sounds: true,
      toolbox: document.getElementById('blockly-toolbox'),
      rtl: false,
      collapse: true,
      comments: true,
      css: true,
      disable: true,
      grid: false,
      maxBlocks: Infinity,
      zoom: {
        controls: true,
        wheel: false,
        startScale: 0.8,
        maxScale: 2,
        minScale: 0.2,
        scaleSpeed: 1.2
      }
    };
    
    this.workspace = Blockly.inject('blockly-div', blocklyOptions);
    this.model.set('workspace', this.workspace);

    // window.addEventListener('resize', this.onContainerResize, false);
    this.onContainerResize();

    Blockly.JavaScript.INFINITE_LOOP_TRAP = null;

    /* Set math blocks color */
    Blockly.Blocks.math.HUE = 35;

  },

  initialize : function() {
    this.$hiddenFileInputElement = $('#hidden-file-input');
    this.$blocklyDivElement = this.$el.find("#blockly-div");
    this.workspace = null; 
    this.$blocklyDivWrapperElement = this.$blocklyDivElement.parent();
    $(window).on('resize.resizeview', this.onContainerResize.bind(this));
    this.render();
  },
  
  onContainerResize : function() {
    var wrapperWidth = this.$blocklyDivWrapperElement.width();
    var wrapperHeight = this.$blocklyDivWrapperElement.height();
    this.$blocklyDivElement.width(wrapperWidth);
    this.$blocklyDivElement.height(wrapperHeight);
    this.forceBlocklySvgResize();
  },

  forceBlocklySvgResize : function() {
    Blockly.svgResize(this.workspace);
  },

  /* Refactor this two functions */
  loadProgram : function() {
    this.$hiddenFileInputElement.click();
  },

  onTextLoad : function(event) {
    this.model.importWorkspaceXml(event.target.result);
  },

  onHiddenFileInputChange : function(event) {
    if (event.target.files.length > 0) {
      var fileToLoad = event.target.files[0];
      var reader = new FileReader();
      reader.onload = $.proxy(this.onTextLoad, this);
      reader.readAsText(fileToLoad);
    }
  },

});
  "use strict";

this.app = app || {};

this.app.views = app.views || {};

this.app.views.ConfigView = Backbone.View.extend({
  initialize : function() {
    this.$el.find("#sensor_hud_checkbox").change(this.changeHUDCheckbox);
    this.$modal = this.$el.find('.modal');
  },

  show : function() {
  	this.$modal.modal('show');
  },

  hide : function() {
    this.$modal.modal('hide');
  },

  changeHUDCheckbox : function() {
    // Hide config modal.
    app.configView.hide();
    app.navBarView.toggleNavbar();
    // Enable / disable HUD.
    if($(this).is(':checked')) {
      app.simulatorModel.enableSensorsHUD();
    } else {
      app.simulatorModel.disableSensorsHUD();
    }
  }
});
"use strict";

this.app = app || {};

this.app.views = app.views || {};

this.app.views.FileSave = Backbone.View.extend({
  defaults: {},

  events: {
    'click .file-download-button' : 'onSaveButtonClick',
    'click .file-cancel-button' : 'onCancelButtonClick',
    'keypress .file-download-name-input': 'onInputKeyPress',
  },

  initialize : function() {
    this.$fileNameInput = this.$el.find(".file-download-name-input");
    this.$modal = this.$el.find(".modal");
  },

	render : function() {
    /* When showed, focus modal */
    this.$modal.on('shown.bs.modal', function () {
      this.$fileNameInput.focus();
    });
  },

  onSaveButtonClick : function() {
    // Modelo
    this.model.downloadWithFileName(this.$fileNameInput.val());
    this.hide();
  },

  onInputKeyPress : function (event) {
    if (event.which == 13) {
      event.preventDefault();
      this.onSaveButtonClick();
    }
  },

  onCancelButtonClick : function() {
    this.hide();
  },

  show : function() {
    this.$modal.modal('show');
  },

  hide : function() {
    this.$modal.modal('hide');
  },
});
"use strict";

this.app = app || {};

this.app.views = app.views || {};

this.app.views.MapsSelectorView = Backbone.View.extend({
  initialize : function() {
    this.$modal = this.$el.find('.modal');
    this.$el.find('.media').click(this.onMapSelectionClick);
  },
  show : function() {
    this.$modal.modal('show');
  },
  hide : function() {
    this.$modal.modal('hide');
  },
  onMapSelectionClick : function () {
    var selectedMap = $(this).attr("id");
    // Hide map selection modal.
    app.mapsSelectorView.hide();
    app.navBarView.toggleNavbar();
    // If there is no code in workspace, change map. Otherwise, ask for confirmation first.
    if(app.blocklyModel.codeIsEmpty()) {
      app.simulatorModel.changeMap(selectedMap);
    }
    else {
      bootbox.dialog({
        message: "Un cambio de mapa eliminará el código existente. Querés continuar?",
        title: "Cambiar Mapa",
        buttons: {
          default: {
            label: "Cancelar",
            className: "btn-default"
          },
          success: {
            label: "Cambiar mapa",
            className: "btn-success",
            callback: function() {
              app.simulatorModel.changeMap(selectedMap);
            }
          }
        }
      });
    }
  }
  
});
"use strict";

this.app = app || {};

this.app.views = app.views || {};

this.app.views.NavBar = Backbone.View.extend({

  events: {
    'click .btn_run' : 'onClickRun',
    'click .btn_pause' : 'onClickPause',
    'click .btn_stop': 'onClickStop',
    'click .btn_save' : 'onClickSave',
    'click .btn_export' : 'onClickExport',
    'click .btn_load' : 'onClickLoad',
    'click .btn_maps': 'onClickMaps',
    'click .btn_config' : 'onClickConfig'
  },

  initialize: function () {
    this.$btn_run = this.$el.find('.btn_run');
    this.$btn_pause = this.$el.find('.btn_pause');
    this.$btn_stop = this.$el.find('.btn_stop');
    this.$btn_save = this.$el.find('.btn_save');
    this.$btn_export = this.$el.find('.btn_export');
    this.$btn_load = this.$el.find('.btn_load');
    this.$btn_maps = this.$el.find('.btn_maps');
    this.$home_navbar_collapse = $('#home-navbar-collapse');
    this.$home_navbar_collapse_button = $('#home-navbar-collapse-button');

    key('ctrl+g, ⌘+g', keyHandler(this.onClickSave));
    key('ctrl+a, ⌘+a', keyHandler(this.onClickLoad));
    key('ctrl+e, ⌘+e', keyHandler(this.onClickRun));
    key('ctrl+p, ⌘+p', keyHandler(this.onClickPause));
    key('ctrl+d, ⌘+d', keyHandler(this.onClickStop));
    key('ctrl+m, ⌘+m', keyHandler(this.onClickMaps));
    
    function keyHandler(handler) {
      return function(event) {
        handler(event);
        event.preventDefault();
        event.stopPropagation();
      }
    }
  },

  onClickConfig : function(event) {
    app.configView.show();
  },

  onClickRun : function(event) {
    var onCompleted = function() {
      this.$btn_run.show();
      this.$btn_pause.hide();
      this.$btn_stop.addClass('disabled');
    }
    var onRun = function() {
      this.$btn_pause.show();
      this.$btn_stop.removeClass('disabled');
      this.$btn_run.hide();
    }
    app.simulatorModel.run($.proxy(onRun, this), $.proxy(onCompleted, this));
    event.stopPropagation();
  },

  onClickPause : function(event) {
    var onPause = function() {
      this.$btn_run.show();
      this.$btn_pause.hide();
    }
    app.simulatorModel.pause($.proxy(onPause, this));
  },

  onClickStop : function(event) {
    var onStop = function() {
      this.$btn_run.show();
      this.$btn_pause.hide();
      this.$btn_stop.addClass('disabled');
    }
    app.simulatorModel.stop($.proxy(onStop, this));
  },

  onClickSave : function(event) {
    app.downloadCodeView.show();
  },

  onClickExport : function(event) {
    app.exportCodeView.show();
  },

  onClickLoad : function(event) {
    app.blocklyView.loadProgram();
  },

  onClickMaps : function(event) {
    app.mapsSelectorView.show();
  },

  toggleNavbar : function() {
    if(this.$home_navbar_collapse.hasClass('in')) {
      this.$home_navbar_collapse_button.click();
    }
  },

  render: function () {
  }

});
"use strict";

this.app = app || {};

this.app.views = app.views || {};

app.views.Simulator = Backbone.View.extend({
  initialize : function () {
    /* Load melonjs game. */
    me.interpreter = null;
    game.onload("simulator-screen");

    // Mobile browser hacks
    if (me.device.isMobile && !navigator.isCocoonJS) {
        // Prevent the webview from moving on a swipe
        window.document.addEventListener("touchmove", function (e) {
            e.preventDefault();
            window.scroll(0, 0);
            return false;
        }, false);
        // Scroll away mobile GUI
        (function () {
            window.scrollTo(0, 1);
            me.video.onresize(null);
        }).defer();
        me.event.subscribe(me.event.WINDOW_ONRESIZE, function (e) {
            window.scrollTo(0, 1);
        });
    }
    $(window).on('resize.resizeview', this.render.bind(this));
    $(window).on('orientationchange', this.render.bind(this));
    this.$screenElement = this.$el.find("#simulator-screen");
    this.$canvasElement = this.$el.find("#simulator-screen > canvas");
    this.render();
  },
  /* Needs refactoring */
  onContainerResize : function() {
    var screenWrapperElement = this.$screenElement.parent();
    var screenWrapperWidth = screenWrapperElement.width();
    var screenWrapperHeight = screenWrapperElement.height();
    var screenWidth = Math.min(screenWrapperWidth, screenWrapperHeight);
    var screenHeight = screenWidth;
    this.$screenElement.width(screenWidth);
    this.$screenElement.height(screenHeight);
    this.$canvasElement.width(screenWidth);
    this.$canvasElement.height(screenHeight);
  },

  enableSimulatorDragging : function() {
    this.$el.draggable({ containment: "window" });
    this.$el.draggable('enable');
  },
  
  disableSimulatorDragging : function() {
    this.$el.draggable({ containment: "window" });
    this.$el.draggable('disable');
    this.$el.attr('style', '');
  },

  resetDraggablePosition : function() {
    if (this.$el.hasClass('content-collapsed')) {
      this.disableSimulatorDragging();
      this.enableSimulatorDragging();
    }
  },

  render : function() {
    this.onContainerResize();
    this.resetDraggablePosition();
  }
});
"use strict";

this.app = app || {};

$(document).ready(function() {
  app.mapsSelectorView = new app.views.MapsSelectorView({el : '#maps-modal-wrapper'});

  app.configView = new app.views.ConfigView({el : '#home-config-wrapper'});

  app.navBarView = new app.views.NavBar({el: '#home-navbar-wrapper'});

  app.blocklyModel = new app.models.Blockly();
  app.blocklyView = new app.views.Blockly({el: '#home-blockly-wrapper', model: app.blocklyModel});

  app.downloadCodeModel = new app.models.FileSave({
    fileExtension : '.xml', 
    defaultFileName : 'xml-code',
    extractCode : $.proxy(app.blocklyModel.exportWorkspaceXml, app.blocklyModel)
  });
  app.downloadCodeView = new app.views.FileSave({el: '#download-code-modal-wrapper', model : app.downloadCodeModel});

  app.exportCodeModel = new app.models.FileSave({
    fileExtension : '.ino', 
    defaultFileName : 'arduino-code',
    extractCode : $.proxy(app.blocklyModel.exportWorkspaceArduino, app.blocklyModel)
  });
  app.exportCodeView = new app.views.FileSave({el: '#export-code-modal-wrapper', model : app.exportCodeModel});

  app.simulatorInterpreterModel = new app.models.SimulatorInterpreter();
  app.simulatorModel = new app.models.Simulator({interpreter : app.simulatorInterpreterModel});
  app.simulatorView = new app.views.Simulator({el : '#home-simulator-wrapper', model : app.simulatorModel});

  app.appView = new app.views.AppView({el : '#page-wrapper'});

});